import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import boot from 'bootstrap';
import store from 'app/redux/store';

import Form from './components/Form';

window.__INIT_SME_LEAD_FORM_APPLICATION__ = () => {
  boot({ getSettings: true }).then(() =>
    render(
      <Provider store={store}>
        <Form />
      </Provider>,
      document.querySelector('#smeAccountLeadForm')
    )
  );
};

/**
 * app start
 */
document.addEventListener(
  'DOMContentLoaded',
  window.__INIT_SME_LEAD_FORM_APPLICATION__
);
